import './App.css';
import RecipeHome from './component/RecipeHome'
function App() {
  return (
    <div className="App">
       <RecipeHome/>
    </div>
  );
}

export default App;
